import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-connect-ach',
  templateUrl: './connect-ach.component.html',
  styleUrls: ['./connect-ach.component.css']
})
export class ConnectAchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
